export default {
  LOAD_STUDENT_OVERVIEW_PAGE_START: 'LoadStudentOverviewPageStart',
  LOAD_STUDENT_OVERVIEW_PAGE_END: 'LoadStudentOverviewPageEnd',
  SELECT_STUDENT_OVERVIEW_PAGE_TAB: 'SelectStudentOverviewPageTab',
  LOAD_STUDENT_HOURS_START: 'LoadStudentHoursStart',
  LOAD_STUDENT_HOURS_END: 'LoadStudentHoursEnd',
  SORT_STUDENT_HOURS: 'SortStudentHours'
};
